import { popoverAnatomy as parts } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/unbound-method
const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys)

export const Popover = defineMultiStyleConfig({
  baseStyle: {
    header: {
      paddingTop: 4,
    },
    popper: {
      width: 'fit-content',
      maxWidth: 'fit-content',
    },
  },
  variants: {
    responsive: {
      content: { width: 'unset' },
    },
    modules: {
      popper: {
        fontFamily: 'Lato',
        '*': {
          fontFamily: 'inherit !important',
        },
      },
      content: {
        width: 'unset',
        p: 0,
        maxH: 96,
        boxShadow: '2xl',
      },
      header: {
        color: 'product.text.dark.header',
        borderBottom: 'none',
        px: 6,
        pt: 6,
        pb: 5,
      },
      body: {
        pt: 1,
        px: 6,
        pb: 6,
      },
    },
    favorite: {
      popper: {
        fontFamily: 'Lato',
      },
      content: {
        borderColor: 'product.border.solid',
        borderRadius: 'lg',
        width: 'unset',
        maxWidth: 'lg',
      },
      header: {
        color: 'product.text.dark.header',
        padding: 4,
        paddingRight: 12,
        borderBottomColor: 'product.border.solid',
      },
      body: {
        padding: 4,
      },
      footer: {
        bg: 'product.gray.50',
        borderTopColor: 'product.border.solid',
        paddingY: 4,
        paddingX: 6,
        borderBottomRadius: 'lg',
      },
      closeButton: {
        top: '18px',
        right: 4,
        padding: 0,
        w: 6,
        h: 6,
      },
      arrow: {
        top: '-1px !important',
        borderWidth: '1px',
        borderLeftColor: 'product.border.solid',
        borderTopColor: 'product.border.solid',
        borderBottom: 'none',
        borderRight: 'none',
        boxShadow: 'none !important',
      },
    },
  },
})
